import { render, staticRenderFns } from "./UserLevelInfoModal.vue?vue&type=template&id=238cd652&scoped=true&"
import script from "./UserLevelInfoModal.vue?vue&type=script&lang=js&"
export * from "./UserLevelInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLevelInfoModal.vue?vue&type=style&index=0&id=238cd652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238cd652",
  null
  
)

export default component.exports